import {StyleSheet} from 'react-native';

import {cloudLight, cloudLighter} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  icon: {
    fontSize: 24,
    width: 24,
    height: 24,
    lineHeight: 24,
    textAlign: 'center',
  },
  avatarPlaceholder: {
    alignItems: 'center',
    backgroundColor: cloudLighter,
    borderColor: cloudLight,
    borderRadius: 12,
    borderStyle: 'dashed',
    borderWidth: 2,
    display: 'flex',
    height: 24,
    width: 24,
    justifyContent: 'center',
    alignSelf: 'center',
  },
  placeholder: {
    lineHeight: 24,
    letterSpacing: 0,
  },
  label: {},
  avatarWrapper: {
    display: 'flex',
    flexDirection: 'row' as const,
    alignItems: 'center',
    alignContent: 'center',
    height: 24,
  },
  avatarWrapperSpacingTop: {
    marginTop: 10,
  },
  avatarWrapperSpacingRight: {
    marginRight: 10,
  },
  avatar: {
    width: 24,
    height: 24,
    minWidth: 24,
    minHeight: 24,
    maxHeight: 24,
    flexGrow: 0,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    overflow: 'hidden',
  },
  avatarSpacingLeft: {
    marginLeft: 2,
    marginRight: 2,
  },
  avatarSpacingRight: {
    marginLeft: 2,
    marginRight: 2,
  },
  suffix: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});
